import ChartLayout from "../../../components/ChartLayout";
import PerformanceSpeedChart from "./PerformanceSpeedChart";
import PerformanceSpeedForm from "./PerformanceSpeedForm";
import PerformanceResult from "../Performance/PerformanceResult";
import useSpuPoints from "../../../stores/spuPoints";
import EmptyChart from "../components/EmptyChart";
import Loading from "../components/Loading";
import { Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import DisplayUnitSelector from "../../SpuChart/components/DisplayUnitSelector";
import useDisplayUnits from "../../SpuChart/displayUnits/useDisplayUnits";

const PerformanceSpeed = () => {
  const { name, info, dataset, performanceSpeed, loading } = useSpuPoints();
  const { fieldsValue, fieldsResult, speedItems } = performanceSpeed;
  const [searchParams, setSearchParams] = useSearchParams();
  const { displayUnits, updateDisplayUnit } = useDisplayUnits(searchParams, setSearchParams);

  if (loading) return <Loading />;

  if (!name || !dataset) return <EmptyChart />;

  return (
    <ChartLayout
      chart={
        <PerformanceSpeedChart
          key={name}
          name={name}
          info={info}
          dataset={dataset}
          performance={fieldsValue}
          multiSpeed={speedItems}
          displayUnits={displayUnits}
        />
      }
      form={
        <Fragment>
          <DisplayUnitSelector displayUnits={displayUnits} onChange={updateDisplayUnit} />
          <PerformanceSpeedForm displayUnits={displayUnits} />
        </Fragment>
      }
      result={<PerformanceResult fieldsResult={fieldsResult} displayUnits={displayUnits} />}
    />
  );
};

export default PerformanceSpeed;
